import {itemRefTargetCollectionId} from '@packages/systems/dynamo/utils/CollectionFieldUtils';
import type {CollectionRecordType as Collection} from '@packages/systems/dynamo/records/CollectionRecord';
import type {FieldType as Field} from '@packages/systems/dynamo/records/Field';
import type {TypeReferenceDef} from '@packages/systems/dynamo/source-types';

const MISSING_COLLECTION_ID = '<!missing_identifier>';

/**
  Utilities for defining type references within and between gateways of
  data sources that are based on Collection and Field records.
 */

/* Define type reference to given Collection record */
export function defineCollectionTypeReference(
  collection: Collection
): TypeReferenceDef {
  return {
    entity: 'Collection',
    // Handle `null` id allowed by the Collection record Flow type
    id: collection._id || MISSING_COLLECTION_ID,
  };
}

/*
  Define type reference to the entity referenced by given Field record

  Determines the referenced collection id from Field record data and
  uses it to define a type reference to that collection.

  If a referenced collection id is not found, we return `null`.
*/
export function defineTypeReferenceForReferenceField(
  field: Field
): TypeReferenceDef | null {
  const referencedCollectionId = itemRefTargetCollectionId(field);

  if (!referencedCollectionId) {
    return null;
  }

  return {
    entity: 'Collection',
    id: referencedCollectionId,
  };
}
